import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import { useNavigate } from "react-router";
import { Ability } from "~auth/Ability.ts";
import { usePermitted } from "~auth/usePermitted.ts";
import { ROUTES } from "~components/routeDefinitions.ts";
import { useIsDesktop } from "~components/shared/useIsDesktop/useIsDesktop.ts";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import { useTranslation } from "~contexts/I18nContext/I18nContext";

export function AddPhotoButton() {
  const isDesktop = useIsDesktop();
  const isPermitted = usePermitted();
  const t = useTranslation();
  const navigate = useNavigate();
  const { number: tenantNumber } = useCurrentTenant();

  if (isDesktop || !isPermitted([Ability.canCreatePhotoDocumentation])) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "1.5rem",
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <Fab
        variant="extended"
        size="small"
        sx={{
          fontSize: "0.7rem",
          px: "1rem",
          color: "var(--color-white)",
          backgroundColor: "var(--color-grey-1)",
        }}
        onClick={() => {
          navigate(ROUTES.photoDocumentationUpload.link({ tenantNumber }));
        }}
      >
        <PhotoCameraIcon sx={{ mr: 1 }} fontSize="small" />
        {t.dashboardAddImages}
      </Fab>
    </Box>
  );
}
